<template>
<div>
    <div class="bookitem">
        <div class="border">
            <div class="f18">
                <nobr>{{books.bookName}}</nobr>
            </div>
            <div class="f17">{{books.slogan}} </div>
        </div>
    </div>

</div>
</template>

<script>
export default {
    name: 'BookItem',
    props: [
        "books"
    ]
}
</script>

<style scoped>
a {
    text-decoration: none;
}

.bookitem {
    width: 50%;
    float: left;
    height: 120px;
}

.border {
    width: 380px;
    height: 60px;
    padding: 20px;
    border: 1px solid #C4CACA;
    border-radius: 8px;

}

.border:hover { 
    border: 1px solid #90DFCA; 
    background: #F6FCFB;

}

.bookitem p {
    padding: 0;
    margin: 15px;
}

.f18 {
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    font-family: Source Han Serif CN;
    font-weight: bold;
    height: 40px;
    color: #9CA6A6;

}

.border:hover .f18 {
    color: #4CCCAA;

}

.f17 {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #9CA6A6;

}

.border:hover .f17 {
    color: #4CCCAA;

}

.f12 {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(155, 166, 166, 1);
}
</style>
